// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button_icon-button__i1NDo","transparentWithBorder":"icon-button_transparentWithBorder__Cls7E"};